import React from 'react';
import PropTypes from 'prop-types';
import questionCss from './Questions.scss'
import css from './MonthYearField.scss'
import Icon from 'SF/MaterialIcon';
import SelectDate from './SelectDate';
import moment from 'moment';

const MonthYearField = (props) => {
  const { isReadOnly, hasError, ...rest } = props;
  const apiDateFormat = 'YYYY-MM-DD'
  const displayDateFormat = 'MMMM YYYY'

  const onDateChange = (value, isValidDate) => {
    if (isValidDate !== null) {
      props.setHasError(!isValidDate)
      props.setValue(value)
    }
  }

  const getEditableField = () => {
    return (
      <div className={css['datePicker']} >
        <SelectDate 
          onDateChange={onDateChange} 
          {...props} 
          monthAndYearOnly
        />
      </div>
    );
  }

  const renderEmptyAnswerBlock = () => <i>No answer provided</i>

  const formatDate = (value) => {
    const date = moment(value, apiDateFormat)
    return date.isValid() ? date.format(displayDateFormat) : value;
  }

  const getReadOnlyField = (value) => <p className={css['date-input-answers']}>{value ? formatDate(value) : renderEmptyAnswerBlock()}</p>

  return (
    <>
      <div>
        {isReadOnly ? getReadOnlyField(rest.value) : getEditableField()}
      </div>
      {!isReadOnly && hasError && (
        <div className={questionCss['input-error-message-block']}>
          <Icon icon="error" /><p>Invalid date</p>
        </div>
      )}
      {!isReadOnly && (
        <div className={questionCss['input-hint-message-block']}>
          <p>E.g: September 1987</p>
        </div>
      )}
    </>
  );
}

MonthYearField.propTypes = {
  value: PropTypes.string,
  questionText: PropTypes.string,
  isReadOnly: PropTypes.bool,
  hasError: PropTypes.bool,
  setValue: PropTypes.func,
  setHasError: PropTypes.func,
  id: PropTypes.number.isRequired
}

export default MonthYearField
